import { Modal } from '@mui/material';
import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { APIError } from '../../../core/utils';
import { toast } from 'react-toastify';
import { APP_URLS } from '../../../api/url';
import API from '../../../api/axios';
import { Carousel } from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css"
import { ThreeDots } from 'react-loader-spinner';

const ViewAttachments = ({ cancelRequestID, title, type }) => {

    const [open, setOpen] = React.useState(false);

    const [images, _images] = useState([])
    const [imagesLoading, _imagesLoading] = useState(false)

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    useEffect(() => {
        if (!cancelRequestID || !open) {
            _images([])
            _imagesLoading(false)
            return
        }
        _imagesLoading(true)
        API.get(`${APP_URLS.AUCTION_CANCEL_RESERVATION_ATTACHMENTS}/${cancelRequestID}/image?user_type=${type}`)
            .then((res) => {
                const resp = res.data;
                if (resp.success === true) {
                    _images(resp.data.items)
                } else {
                    toast.error(resp.message, {
                        position: toast.POSITION.TOP_RIGHT,
                    });
                }
            })
            .catch(function (error) {
                let error_message = APIError(error);
                toast.error(error_message, {
                    position: toast.POSITION.TOP_RIGHT,
                });
            }).finally(() => {
                _imagesLoading(false)
            })
    }, [open, cancelRequestID])

    return (
        <>
            <StyledSpan onClick={handleOpen}>{title}</StyledSpan>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <ModalWrapper>
                    <h3>Attachments</h3>
                    {imagesLoading || images.length == 0 ?
                        <div className='images-loader'>
                            {imagesLoading ?
                                <ThreeDots
                                    height="150"
                                    width="150"
                                    radius="9"
                                    color="#637df4"
                                    ariaLabel="three-dots-loading"
                                    wrapperStyle={{}}
                                    wrapperClass="spinner"
                                    visible={true}
                                />
                                :
                                <span className='not-found'> No attachments found.</span>
                            }
                        </div>
                        : <Carousel
                            showThumbs={false}
                            showIndicators={false}
                            showArrows={true}
                            showStatus={false}
                        >
                            {images.map((image) => {
                                return <img src={image.url} key={image.url} className='image' />
                            })}
                        </Carousel>
                    }
                </ModalWrapper>
            </Modal>
        </>
    )
}

export default ViewAttachments

const StyledSpan = styled.span`
    color: #5D78FF;
    cursor: pointer;
    font-style: italic;
    font-size: 16px;
    font-weight: 600;
`

const ModalWrapper = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    min-width: 400px;
    width: 40vw;
    background-color: white;
    border: 8px;
    max-height: 60vh;
    border-radius: 6px;
    padding: 16px;
    outline: none;
    h3{
        text-align: center;
    }
    .carousel.carousel-slider .control-arrow{
        top: 40%;
        bottom: unset;
        opacity: 100%;
        min-height: 100px;
        border-radius: 4px;
        background: rgba(0, 0, 0, 0.2);
    }
    .image{
        height: 45vh;
        object-fit: contain;
    }
    .images-loader{
        height: 45vh;
        position: relative;
        .spinner, .not-found{
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
        }
        .not-found{
            font-style: italic;
            font-size: 18px;
            font-weight: 500;
            color: #ff0000ed;
        }
    }
`
